import(/* webpackMode: "eager" */ "/home/ubuntu/Websites/.releases/2solutions-checkout-20261009/src/app/thank-you/page.tsx");
